
import * as ipxRuntime$hHerU8r0uA from '/Users/air/Projects/EMCI/node_modules/@nuxt/image-edge/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$hHerU8r0uA, defaults: {} }
}
        